// Persist the selected Career view (cview) and Lens (lview) so the choice holds across page
// navigation — the landing carousels and the topbar dropdowns both read/write through here, so a
// view picked on one page is still reflected after navigating away and back.

const KEY = (param: string) => `ir.view.${param}`;

export function getView(param: "cview" | "lview"): string | null {
  try {
    return localStorage.getItem(KEY(param));
  } catch {
    return null;
  }
}

export function setView(param: "cview" | "lview", key: string) {
  try {
    localStorage.setItem(KEY(param), key);
  } catch {
    // ignore — storage may be unavailable
  }
}
